// Stat: one number and what it counts. A zero is always neutral ("0 failing" in red reads as an
// alarm when it is the opposite). Ported from the Humint Assistant's components/ui/stat.tsx.
import type { ComponentProps, ReactNode } from 'react';
import { cn } from './cn';

export type StatTone = 'neutral' | 'accent' | 'signal' | 'success' | 'warning' | 'danger';

const TONE: Record<StatTone, string> = {
  neutral: 'text-ink-display',
  accent: 'text-accent-display',
  signal: 'text-signal-ink',
  success: 'text-success-ink',
  warning: 'text-warning-ink',
  danger: 'text-danger-ink',
};

export interface StatProps extends Omit<ComponentProps<'div'>, 'children'> {
  value: ReactNode;
  label: ReactNode;
  tone?: StatTone;
}

export function Stat({ value, label, tone = 'neutral', className, ...props }: StatProps) {
  return (
    <div className={cn('min-w-0 rounded-lg border border-hairline bg-page px-4 py-3', className)} {...props}>
      <div className={cn('text-2xl font-semibold leading-none tabular-nums', TONE[value === 0 ? 'neutral' : tone])}>{value}</div>
      <div className="mt-1.5 text-xs text-ink-muted">{label}</div>
    </div>
  );
}
